const basePath = '/job/employer/';

import getProtocolUrl from '../../shared/getProtocolUrl';

/**
 * prefixes @url with '/job/employer' in production
 * or just / locally. Used in mainRoutes etc
 *
 * @param {string} url to prefix
 */
export const createUrl = (url) => basePath + url.replace(/^\//, '');

// Creates a polymorphic api URL that will be prefetched
// with localhost:PORT if on server, or simply '' if in browser
export const createAPIUrl = (url) => {
    // localhost or ''
    const localServerUrl = getProtocolUrl.get();

    const resolvedUrl = localServerUrl + createUrl(url);
    return resolvedUrl;
};

export const createExternalUrl = (path) => {
    const finnServer = global.__FINN_ENV__.finnServer;
    return `https:${finnServer}${path}`;
};
